import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LogoService {
  private logoSubject = new BehaviorSubject<string | null>(null);

  constructor() { }

  setLogo(logo: string) {
    this.logoSubject.next(logo);
    sessionStorage.setItem('lkighty445dh==', logo);
  }

  getLogo(): Observable<string | null> {
    // Check sessionStorage first (optional)
    const stored = sessionStorage.getItem('lkighty445dh==');
    if (stored && !this.logoSubject.value) {
      this.logoSubject.next(stored);
    }
    return this.logoSubject.asObservable(); // Components will reactively listen to this
  }
}
